import defaultState from './defaultState'
import { actionTypes } from '../../../actions/src'

const timezoneReducer = (state = { ...defaultState }, { type, payload }) => {

  switch (type) {

    case actionTypes.FETCH_TIMEZONES:
      return { ...state,
        status: {
          ...state.status,
          isFetching: true,
          hasError: false
        }
      }
    case actionTypes.FETCH_TIMEZONES_SUCCESS:
      return { ...state,
        status: {
          ...state.status,
          isFetching: false,
          hasData: true,
          hasError: false
        },
        data: payload
      }
    case actionTypes.FETCH_TIMEZONES_ERROR:
      return { ...state,
        status: {
          ...state.status,
          isFetching: false,
          hasData: false,
          hasError: true
        },
        data: payload
      }
    default:
      return state

  }

}

export default timezoneReducer
